import { dataSmileyStarSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconSmileyStarSolid = /*#__PURE__*/createIcon(dataSmileyStarSolid)
export default IconSmileyStarSolid
